import { Harmonizer } from 'color-harmony'
import Gradient from 'javascript-color-gradient'
import random from './random'

const harmonizer = new Harmonizer()
const colorGradient = new Gradient()

export default (x, y, center) => {
    const hue = Math.floor(
        (((Math.PI + Math.atan2(center - y, x - center)) * 180) /
            Math.PI /
            360) *
            255
    )
    const saturation =
        (100 * Math.sqrt(Math.pow(center - x, 2) + Math.pow(center - y, 2))) /
        center
    colorGradient.setMidpoint(random(100, 120))
    colorGradient.setGradient(
        ...harmonizer.harmonize(
            `hsl(${hue},  ${saturation}%, 75%)`,
            'fiveToneA'
        )
    )
    return colorGradient.getArray()
}
